import React from 'react';
import { useSelectedTheme, useTranslate } from '../../../Hooks';
import Lock3Icon from '../../../assets/icons/Lock3Icon';
import { Box, Tooltip } from '@material-ui/core';

import useStyles from './styles';
function PropertyLockBadges({ propertyLockStatus }) {
  const isLocked = propertyLockStatus?.toLowerCase() === 'yes';

  const { translate } = useTranslate('NewPropertiesView');

  const {
    theme: { palette },
  } = useSelectedTheme();

  const styles = useStyles();

  return (
    <>
      {isLocked && (
        <>
          <Tooltip
            size='large'
            title={translate(
              'this-property-is-locked-cant-add-units-for-this-property'
            )}
            placement='top'
          >
            <Box className={styles.badgeSection}>
              <Lock3Icon
                width='20'
                height='20'
                fill={palette.button.secondary_fg}
              />
            </Box>
          </Tooltip>
        </>
      )}
    </>
  );
}

export default PropertyLockBadges;
